import common from './common'

function inputRetention(obj) {
    //入力保持
    obj.specificDate = common.getStore(obj, 'specificDate')
    obj.specificTime = common.getStore(obj, 'specificTime')

    //現在の年月を取得しセット
    let today = new Date()
    obj.nowYearMonth = today.getFullYear() + '年' + (today.getMonth() + 1) + '月'

    // 中型の表示品目数
    obj.mediumView = common.countMediumView(obj)
    // 小型の表示品目数
    obj.smallView = common.countSmallView(obj)
}

//カレンダー作成
function createCalendar(obj) {
    //カレンダーに表示する開始日を取得
    let startDate = getStartDate(obj)

    //通常は2週間表示　大型を含む場合、年末付近(12/22～1/5)は配達不可の日があるので3週間表示
    let today = new Date()
    let nowMonth = today.getMonth() + 1
    let nowDate = today.getDate()
    let dispTerm = obj.siteCodeInfo[0].COLLECTION_DATE_SELECT_RANGE - 1;
    if(obj.is_large && ((nowMonth === 12 && nowDate > 21) || (nowMonth === 1 && nowDate < 6))){
        dispTerm += 7
    }

    //最終日取得
    let lastDate = addDate(getStartDate(obj), dispTerm)

    //カレンダー表示に使用する配列
    let calendar = []
    let monthRow = []
    let weekRow = []

    //該当週の最終日付
    let weekLaterDate

    //年,月,日格納用の変数
    let year
    let month
    let date

    //対象月の最初の表示日
    let targetMonthStartDate
    //対象月の最終表示日
    let targetMonthLastDate

    //対象月の最初の表示日の週
    let targetMonthStartDateWeek

    //対象月の最終表示日の週
    let targetMonthLastDateWeek

    //開始日の週の日曜日
    let calendarStartDate

    //表示する月分ループ
    for (let tartgetDay = getStartDate(obj); compareDateYearMonth(tartgetDay, lastDate); tartgetDay.setMonth(tartgetDay.getMonth() + 1, 1)) {
        monthRow = []
        monthRow.weekRows = []

        //対象月の最初の表示日取得
        targetMonthStartDate = tartgetDay.getMonth() == startDate.getMonth() ? tartgetDay : new Date(tartgetDay.getFullYear(), tartgetDay.getMonth(), 1)

        //対象月の最終表示日取得
        targetMonthLastDate = tartgetDay.getMonth() == lastDate.getMonth() ? lastDate : new Date(tartgetDay.getFullYear(), tartgetDay.getMonth() + 1, 0)

        //対象月の最初の表示日が何週目か取得
        targetMonthStartDateWeek = Math.floor((targetMonthStartDate.getDate() - targetMonthStartDate.getDay() + 12) / 7)

        //対象月の最終表示日時が何週目か取得
        targetMonthLastDateWeek = Math.floor((targetMonthLastDate.getDate() - targetMonthLastDate.getDay() + 12) / 7)

        //開始日の週の日曜日を取得
        calendarStartDate = addDate(new Date(targetMonthStartDate), (-1 * targetMonthStartDate.getDay()))

        //表示する週分のループ
        for (let week = targetMonthStartDateWeek; week <= targetMonthLastDateWeek; week++) {
            weekRow = []

            //該当週の最終日付を取得
            weekLaterDate = addDate(new Date(calendarStartDate), 6)

            //1週間分のループ
            for (let day = new Date(calendarStartDate); day.getTime() <= weekLaterDate.getTime(); addDate(day, 1)) {
                year = day.getFullYear()
                month = day.getMonth() + 1
                date = day.getDate()

                //カレンダーに表示する開始日(翌日)より前の日付 OR 最終日以降はブランクをセット
                if (day.getTime() < targetMonthStartDate.getTime() || day.getTime() > targetMonthLastDate.getTime()) {
                    weekRow.push('')
                }
                // サービス期間が設定されている場合、サービス期間外の日付はブランクをセット
                else if (checkServiceRangeSetting(obj) && !checkWithinTheServiceRange(obj, day)) {
                    weekRow.push('')
                } else {
                    let serviceOfDate = getServiceDay(obj, year, month, date)
                    if (obj.is_large && ((month === 12 && date > 26) || (month === 1 && date < 8))) {
                        // 大型含めの場合に、12/27 ~ 1/7まで選択できないように
                        serviceOfDate = '0'
                    }

                    weekRow.push({
                        year: year,
                        month: month,
                        date: date,
                        service: serviceOfDate
                    })
                }
            }

            //次の週の日曜日にを更新
            addDate(calendarStartDate, 7)

            monthRow.weekRows.push(weekRow)
        }

        monthRow.yearMonth = tartgetDay.getFullYear() + '年' + (tartgetDay.getMonth() + 1) + '月'

        calendar.push(monthRow)
    }

    obj.calendar = calendar
}

//日付を年、月で比較
function compareDateYearMonth(date1, date2) {
    let date1Num = parseInt(String(date1.getFullYear()) + ('0' + (date1.getMonth() + 1)).slice(-2));
    let date2Num = parseInt(String(date2.getFullYear()) + ('0' + (date2.getMonth() + 1)).slice(-2));

    return date1Num <= date2Num;
}

//日付加算関数
function addDate(date, addDay) {
    date.setDate(date.getDate() + addDay)

    return date
}

/**
 * 日付(00:00:00)取得
 */
function getStartDate(obj) {
    let today = new Date()
    // 大型含む場合
    if (obj.is_large) {
        // 3日後の日付を取得
        today.setDate(today.getDate() + 3)
    } else { // 大型含まない場合
        // 当日20時以前の場合、翌日となる
        if (today.getHours() < 20) {
            today.setDate(today.getDate() + 1)
        } else { // 当日20時以後の場合、翌々日となる
            today.setDate(today.getDate() + 2)
        }
    }
    return new Date(today.getFullYear(), today.getMonth(), today.getDate())
}

//大型取得、有無判定
function isLarge(obj) {
    //TODO 大型のソース変更に伴い要修正
    common.getStore(obj, 'largeItems').forEach(largeItem => {
        if (largeItem.unit != 0) obj.is_large = 1
    });
}

//SGM集荷サービスマスタデータ取得
function getService(obj) {

    let addressFormSelected = common.getStore(obj, 'addressFormSelected')
    let JIS5CD = addressFormSelected.JIS5CD
    let splitPostCode = addressFormSelected.YUBIN.split('-')
    let postCode = splitPostCode[0] + splitPostCode[1]

    let url = common.constant.GET_SERVICE_URL + 'jis5cd=' + JIS5CD + '&yubin=' + postCode + '&is_large=' + obj.is_large

    let func = (response) => {

        const data = response.data

        //回収可能曜日の情報をセット
        obj.sgm_pickup_service = data.sgm_pickup_service

        //回収可能時間帯の情報をセット
        data.pickup_times.forEach((pickup_time, index) => {
            pickup_time['service'] = getServiceTime(obj, index)
        });

        obj.pickup_times = data.pickup_times

        // 選択可能な時間帯を絞る
        let available = obj.pickup_times.filter(pickup_time => {
            return pickup_time['service'] == 1
        })
        if (available.length === 1 && obj.specificTime === '') {
            obj.specificTime = available[0]
        }
        //カレンダーの作成
        createCalendar(obj)
    }

    //SGM集荷サービスマスタデータをAPIから取得
    common.executeAxiosGet(url, func, obj)
}


//回収可能曜日を取得
function getServiceDay(obj, year, month, date) {
    let this_day = new Date(year, month - 1, date)
    let service = obj.is_large == 1 ? obj.sgm_pickup_service['SPECIFY_' + obj.dayStrArray[this_day.getDay()].day] : 1
    return service
}

//回収可能時間帯を取得
function getServiceTime(obj, index) {
    let service = obj.is_large == 1 ? obj.sgm_pickup_service['SPECIFY_' + common.constant.SPECIFIC_TIME_STR_ARRAY[index]] : 1
    return service
}

//選択した回収希望日をプロパティにセット
function selectDate(obj, year, month, date) {
    obj.specificDate = year + '/' + month + '/' + date
}

//選択した回収希望時間帯をプロパティにセット
function selectTime(obj, time) {
    obj.specificTime = time
}

//お客様情報の入力へ押下時
function submitSpecificDatetimeForm(obj, path) {

    //エラーメッセージ、エラーフラグを初期化
    obj.error.invalid_specificDate = false
    obj.error.invalid_specificTime = false
    obj.setErrorFlg(false)

    //日入力チェック
    if (obj.specificDate === '') {
        obj.error.invalid_specificDate = true
        obj.setErrorFlg(true)
    }

    //時間入力チェック
    if (obj.specificTime === '') {
        obj.error.invalid_specificTime = true
        obj.setErrorFlg(true)
    }

    //エラーフラグをストアにセット
    common.setStore(obj, 'errorFlg', obj.errorFlg())

    //ストアに入力情報を保存
    common.setStore(obj, 'specificDate', obj.specificDate)
    common.setStore(obj, 'specificTime', obj.specificTime)
    common.setStore(obj, 'is_large', obj.is_large)

    //画面遷移先をセット
    common.setRoute(obj, path)
}

function pageBack(obj) {
    let path = ''
    if (obj.smallView === 0 && obj.mediumView === 0) {
        path = common.constant.LARGE_ITEMS_PATH
    } else if (obj.smallView === 0) {
        path = common.constant.MEDIUM_ITEMS_PATH
    } else {
        path = common.constant.SMALL_ITEMS_PATH
    }

    common.pageBack(obj, path)
}

// サービス開始日とサービス終了日が設定されているかチェック
function checkServiceRangeSetting(obj) {
    return (obj.siteCodeInfo[0].COLLECTION_SERVICE_START_DATE != null &&
            obj.siteCodeInfo[0].COLLECTION_SERVICE_END_DATE != null);
}

// 指定日時がサービス期間内であるかチェック
function checkWithinTheServiceRange(obj, compDate) {
    if(checkServiceRangeSetting(obj)) {
        let serviceStartDate = new Date(obj.siteCodeInfo[0].COLLECTION_SERVICE_START_DATE)
        let serviceEndDate = new Date(obj.siteCodeInfo[0].COLLECTION_SERVICE_END_DATE)

        return (serviceStartDate <= compDate && compDate <= serviceEndDate);
    }
    return false
}

export default {
    common,
    inputRetention,
    isLarge,
    getService,
    getServiceTime,
    selectDate,
    selectTime,
    submitSpecificDatetimeForm,
    pageBack,
}
